export default class AppConfigService {
    setDateFormat(dateFormat) {
        localStorage.setItem("Shomoshtee_DateFormat", dateFormat);
    }

    getDateFormat() {
        return localStorage.getItem("Shomoshtee_DateFormat") || "dd/MM/yyyy";
    }

    removeDateFormat() {
        localStorage.removeItem("Shomoshtee_DateFormat");        
    }
}

